<template>
  <div class="locations-ordering flex flex-space-between flex-align-items-start mt-110">
    <div class="locations-ordering-wrapper">
      <h3>Как заказать доставку груза в {{ locationText }}</h3>
      <div v-for="item, index in items" :key="index" class="locations-ordering-item flex flex-space-between flex-align-items-start mb-20">
        <vz-icon
          :url="item.imgUrl"
          variant="primary"
          no-masked-icon
          class="mr-10"
          size=24
        />
        <div class="locations-ordering-item-text">
          <h3 class="text-bold mb-10">{{ item.title }}</h3>
          {{ item.text }}
          <nuxt-link 
            v-if="item.link"
            :to="item.link.to"
            target="_blank"
            class="text-decoration-underline"
          >
            {{ item.link.title }}
          </nuxt-link>
        </div>
      </div>
    </div>
    <public-card-info :has-round="false" img-url="/images/pages/locations/phone.png">
      Для заказа грузоперевозки в <b>{{ locationText }}</b> вы можете воспользоваться одним из трех способов оформления заявки
      <div class="color-primary mt-10">
        Если у вас остались вопросы, наши менеджеры с удовольствием на них ответят<br>
        <vz-button
          large
          class="mt-20 mb-10"
          variant="primary"
          @click="openFeedbackModal"
        >
          Оставить заявку
        </vz-button>
      </div>
    </public-card-info>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCityStore } from '~/stores/city'
import { useTerminalStore } from '~/stores/terminal'
import PublicCardInfo from '~/components/public/public-card-info.vue'

const { terminalList } = storeToRefs(useTerminalStore())
const { from } = storeToRefs(useCityStore())
const { $showDialog } = useNuxtApp()

const items =  computed(() => {
 return [
    {
      imgUrl: '/svg/vz-person.svg',
      title: 'В личном кабинете',
      text: `При оформлении заказа через личный кабинет Vozovoz действует фиксированная скидка 2% на межтерминальную перевозку и скидка 5% на адресный забор и доставку товара. В случае одновременного заказа забора и доставки груза по России из/в ${locationText2.value} на общую сумму услуг действует скидка 10%.`
    },
    {
      imgUrl: '/svg/phone-in-talk.svg',
      title: 'По телефону горячей линии',
      text: 'Менеджеры Vozovoz помогут в расчёте стоимости заказа, а также на всех этапах его оформления и отслеживания хода перевозки. Они оформят заказ и проконсультируют по всем возможным вопросам.'
    },
    {
      imgUrl: '/svg/vz-signature.svg',
      title: 'На терминале транспортной компании',
      text: `Оформить перевозку груза из ${locationText2.value} можно без предварительной заявки, при сдаче груза на один из терминалов Vozovoz. Узнайте расположение и режим работы `,
      link: {
        title: 'филиала',
        to: addressLink.value
      }
    }
  ]
})

const addressLink = computed(() => {
  return `/address/${!from.value.rcl_guid ? from.value.translit : ''}`
})

const locationTypeText = computed(() => {
  return from.value.type + '. ' + from.value.name
})

const locationText = computed(() => {
  return `${from.value?.prepositional_name || locationTypeText.value }`
})

const locationText2 = computed(() => {
  return `${from.value?.prepositional_name2 || locationTypeText.value }`
})

function openFeedbackModal(): void {
  $showDialog({ name: 'feedback' })
}
</script>

 